import React from 'react';

const AudioDebug = ({ audioData }) => {
  if (!audioData) return null;

  return (
    <div style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      background: 'rgba(0,0,0,0.8)',
      color: 'white',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '12px',
      zIndex: 1000
    }}>
      <div>Average: {audioData.average.toFixed(3)}</div>
      <div>Peak: {audioData.peak.toFixed(3)}</div>
      <div>Bass: {audioData.bass.toFixed(3)}</div>
      <div>Mid: {audioData.mid.toFixed(3)}</div>
      <div>Treble: {audioData.treble.toFixed(3)}</div>
    </div>
  );
};

export default AudioDebug;